import { useEffect, useState } from "react";
import ApplyForAdmission from "../components/ApplyForAdmission";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import HeaderOne from "../components/HeaderOne";
import { useLoader } from "../context/LoaderContext";
import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";
import { fetchSchoolDetails } from "../api/SchoolDetailsApi";
import { fetchMunicipality } from "../api/AdmissionApi";
import { useAllDataContext } from "../context/AllDataContext";
import { FetchAllApi } from "../components/FetchAllApi";
import PrivacyPolicyInner from "../components/PrivacyPolicyInner";
import { useLocation } from "react-router-dom";

const ApplyAdmissionPage = () => {
  const { setLoading } = useLoader();
  const { schoolDetailsData, setSchoolDetailsData } = useSchoolDetailsContext();
  const [municipalityOption, setMunicipalityOption] = useState([]);
  const { allData, setAllData } = useAllDataContext();
  const location = useLocation();

  const policiesData = allData.policiesData;

  const section = location.state?.section;
  const admissionBannerData = allData.allBannerData[0]?.admission_title;

  useEffect(() => {
    if (section) {
      const el = document.getElementById(section.toLowerCase());
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [section]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchMunicipality()])
      .then(([municipality]) => {
        setMunicipalityOption(municipality);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch(() => {
        console.error("Server Error");
        setTimeout(() => {
          setLoading(false);
        }, 500);
      });
  }, [setLoading]);
  FetchAllApi({ schoolDetailsData, setAllData, setLoading });

  useEffect(() => {
    if (schoolDetailsData.length === 0) {
      Promise.all([fetchSchoolDetails()])
        .then(([schoolDetailsData]) => {
          setSchoolDetailsData(schoolDetailsData);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
  }, [schoolDetailsData.length, setSchoolDetailsData]);
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb heading={admissionBannerData} title={"Admission"} />

      {/* PrivacyPolicyInner */}
      <PrivacyPolicyInner policiesData={policiesData} />

      {/* ApplyForAdmission */}
      <ApplyForAdmission municipalityOption={municipalityOption} />

      {/* CertificateOne */}
      {/* <CertificateOne /> */}

      {/* FooterOne */}
      <FooterThree />
    </>
  );
};

export default ApplyAdmissionPage;
